import styled from 'styled-components';

export const SkeletonHomeWrapper = styled.div`
	position: relative;
	z-index: 10;
	.main-wrapper {
		margin-top: 60px;
		position: relative !important;
		border: 0px solid red;
		animation: blink 1s linear infinite alternate;
		@keyframes blink {
			from {
				opacity: 0.3;
			}
			to {
				opacity: 1;
			}
		}
		.flex {
			display: flex;
			justify-content: space-between;
			padding-bottom: 60px;
			.left-box {
				padding-right: 50px;
				width: 100%;
				p {
					max-width: 130px;
					width: 100%;
					height: 30px;
					border-radius: 8px;
					background: #f2f2f2;
				}
				h2 {
					margin-top: 22px;
					width: 89%;
					height: 120px;
					border-radius: 16px;
					background: #f2f2f2;
				}
				.more-btn {
					margin-top: 60px;
					border-radius: 44.828px;
					width: 160px;
					height: 54px;
				}
			}
			.right-box {
				max-width: 690px;
				width: 100%;
				padding-left: 30px;
				.banner {
					width: 660px;
					height: 0;
					padding-bottom: 66%;
					border-radius: 30px;
					background: #f2f2f2;
				}
			}
		}
		.swiper-pagination {
			display: flex;
		}
		.swiper-pagination-bullet {
			width: 48px;
			height: 1px;
			cursor: pointer;
			border-radius: 0;
			margin-top: -20px !important;
		}
		.swiper-pagination-bullet-active {
			background-color: #000;
		}
		.swiper-button-next {
			background: url(/images/icon-next.svg) no-repeat;
			background-position: center;
			width: 20px;
			right: -95px;
			z-index: 10;
		}
		.swiper-button-prev {
			background: url(/images/icon-prev.svg) no-repeat;
			width: 20px;
			left: -95px;
			z-index: 10;
		}
		.swiper-button-next::after,
		.swiper-button-prev::after {
			display: none;
		}
	}
	@media screen and (max-width: 768px) {
		.main-wrapper {
			margin-top: 7px;
			.flex {
				flex-wrap: wrap;
				.left-box {
					margin-left: 2px;
					margin-top: 0;
					p {
						margin-top: 25px;
						margin-left: 6px;
					}
					h2 {
						margin-top: 14px;
						margin-left: 8px;
						max-width: 100%;
					}
					.more-btn {
						margin-top: 20px !important;
						margin-left: 8px;
						border-radius: 33.621px;
						font-size: 12px;
						line-height: 38px;
						width: 120px;
						height: 40px;
					}
				}
				.right-box {
					margin-top: 28px;
					width: 100%;
					padding-left: 0;
					.banner {
						width: 100%;
						height: 0;
						padding-bottom: 75%;
						border-radius: 20px;
					}
				}
			}
			.swiper-wrapper {
				padding-bottom: 27px;
			}
			.swiper-pagination {
				display: flex;
				justify-content: center;
			}
			.swiper-pagination-bullet {
				margin-top: 0px !important;
			}
			.swiper-button-next {
				background: url(/images/icon-mo-next.svg) no-repeat;
				background-position: center;
				width: 11px;
				top: 34px;
				right: 8px;
				z-index: 10;
			}
			.swiper-button-prev {
				background: url(/images/icon-mo-next.svg) no-repeat;
				transform: rotate(180deg);
				width: 11px;
				top: 22px;
				left: 82%;
				z-index: 10;
			}
		}

		.article-wrap {
			margin-top: 60px;
			margin-left: 2px;
			.title {
				font-size: 22px;
				margin-bottom: 20px;
				margin-left: 10px;
			}
			.flex-wrap {
				flex-direction: column;
				.left-box {
					padding-right: 0;
				}
			}
			.card-box {
				display: block;
				border-bottom: 1px solid #eee;
				padding-bottom: 30px;
				margin-bottom: 30px;
				/* &:last-child {
					padding-bottom: 0;
					margin-bottom: 0;
				} */
			}
		}
		.result {
			height: 400px;
			.result-box {
				width: 220px;
				height: 132px;
				p {
					padding-top: 35px;
					font-size: 14px;
				}
			}
		}
		.btn-wrap {
			top: 0px !important;
			margin-top: 30px;
			.more {
				border-radius: 76px;
				width: 117px;
				height: 46px;
				p {
					font-size: 13px;
					font-weight: 600;
					line-height: 44px;
				}
			}
		}
	}
`;
export const SkeletonHomeArticle = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.article-wrap {
		margin-top: 0px;
		margin-left: 2px;
		.card-box {
			display: block;
			border-bottom: 1px solid #eee !important;
			padding-bottom: 49px;
			margin-bottom: 50px;
		}
		.article-card {
			display: flex;
			gap: 37px;
			align-items: center;
			.article-img {
				width: 250px;
				height: 0;
				padding-bottom: 19.8%;
				border-radius: 16px;
				border-radius: 16px;
				background: #f2f2f2;
			}
			.text-box {
				max-width: 584px;
				width: 100%;
				.tag-box {
					display: flex;
					gap: 12px;
					.cate {
						border-radius: 6px;
						background: #f2f2f2;
						max-width: 172px;
						width: 100%;
						height: 18px;
						margin-top: 5px;
					}
				}
				h3 {
					margin-top: 7px;
					max-width: 444px;
					width: 100%;
					border-radius: 8px;
					background: #f2f2f2;
					height: 30px;
				}
				.content {
					margin-top: 9px;
					border-radius: 10px;
					background: #f2f2f2;
					height: 47px;
					padding-right: 30px;
					max-width: 594px;
					width: 100%;
				}
				.flex {
					margin-top: 16px;
					border-radius: 6px;
					background: #f2f2f2;
					max-width: 226px;
					width: 100%;
					height: 18px;
				}
			}
		}
		.right-box {
			max-width: 256px;
			width: 100%;
			.shapes-box {
				width: 100%;
				height: 320px;
				border-radius: 18px;
				top: -82px;
				left: -2px;
				margin-bottom: 30px;
				border-radius: 18px;
				background: #f2f2f2;
			}
		}
	}
	@media screen and (max-width: 768px) {
		.article-wrap {
			margin-top: 0px;
			margin-left: 2px;
			.title {
				font-size: 22px;
				margin-bottom: 20px;
				margin-left: 10px;
			}
			.flex-wrap {
				flex-direction: column;
				.left-box {
					padding-right: 0;
				}
			}
			.card-box {
				display: block;
				border-bottom: 1px solid #eee;
				padding-bottom: 30px !important;
				margin-bottom: 30px !important;
				/* &:last-child {
					padding-bottom: 0;
					margin-bottom: 0;
				} */
			}
			.article-card {
				flex-wrap: wrap;
				gap: 16px;
				.article-img {
					width: 100%;
					height: 0;
					padding-bottom: 55.4%;
					border-radius: 16px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
				}
				.text-box {
					max-width: 584px;
					width: 100%;
					margin-left: 10px;
					.tag-box {
						gap: 12px;
						.cate {
							font-size: 12px;
							font-weight: 400;
						}
					}
					h3 {
						margin-top: 6px;
						font-size: 18px;
						overflow: hidden;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
					}
					.content {
						margin-top: 8px;
						font-size: 12px;
						padding-right: 0px;
					}
					.flex {
						margin-top: 9px;
						p {
							font-size: 12px;
							margin-right: 21px;
						}
						.name {
							font-size: 12px;
							margin-right: 21px;
						}
						.date {
							font-size: 12px;
						}
					}
				}
			}
			.right-box {
				display: none;
			}
		}
		.result {
			height: 400px;
			.result-box {
				width: 220px;
				height: 132px;
				p {
					padding-top: 35px;
					font-size: 14px;
				}
			}
		}
		.btn-wrap {
			top: 0px !important;
			margin-top: 30px;
			.more {
				border-radius: 76px;
				width: 117px;
				height: 46px;
				p {
					font-size: 13px;
					font-weight: 600;
					line-height: 44px;
				}
			}
		}
	}
`;
export const SkeletonSeriesWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.series-wrap {
		max-width: calc(100% - 5px);
		overflow: visible;
		margin: 0 auto;
		.swiper {
			overflow: visible !important;
		}
	}
	.banner {
		width: 100%;
		height: 240px;
		position: relative;
		border-radius: 18px;
		background: #f2f2f2;
	}
`;
export const SkeletonListWrapper = styled.div`
	max-width: 1245px;
	width: 100%;
	margin: 0 auto;
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.mo-top-box,
	.mo-content,
	.mo-banner-wrap {
		display: none;
	}

	.flex-wrapper {
		display: flex;

		.left {
			max-width: 880px;
			width: 100%;
			border-right: none !important;
			padding-right: 0px;
			.article-wrap {
				margin-top: 0px;
				margin-left: 2px;
				.title {
					font-size: 0px;
					font-weight: 700;
					line-height: 150%;
					margin-bottom: 53px;
				}
				.flex-wrap {
					display: flex;
					justify-content: space-between;
					.left-box {
						width: 100% !important;
					}
				}
				.card-box {
					display: block;
					border-bottom: 1px solid #eee !important;
					padding-bottom: 49px !important;
					margin-bottom: 54px !important;

					&:last-child {
						border-bottom: none;
					}
				}
				.article-card {
					display: flex;
					gap: 37px;
					align-items: center;
					.article-img {
						width: 250px;
						height: 0;
						padding-bottom: 68.8%;
						border-radius: 16px;
						background: #f2f2f2;
					}
					.text-box {
						max-width: 584px;
						width: 100%;
						.tag-box {
							max-width: 172px;
							width: 100%;
							border-radius: 6px;
							height: 18px;
							background: #f2f2f2;
							margin-top: 5px;
						}
						h3 {
							margin-top: 7px;
							border-radius: 8px;
							background: #f2f2f2;
							height: 30px;
							max-width: 444px;
							width: 100%;
						}
						.content {
							margin-top: 9px;
							border-radius: 10px;
							background: #f2f2f2;
							height: 48px;
						}
						.flex {
							max-width: 226px;
							width: 100%;
							margin-top: 16px;
							border-radius: 6px;
							background: #f2f2f2;
							height: 18px;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 768px) {
		margin-top: 0px;
		padding: 0;
		.mo-top-box {
			display: flex;
			align-items: center;
			gap: 24px;
			.topimgs {
				width: 68px;
				height: 68px;
				border-radius: 50%;
			}
			.text-box {
				h3 {
					font-size: 20px;
					font-weight: 700;
				}
				p {
					margin-top: 6px;
					font-size: 13px;
					font-weight: 400;
				}
			}
		}

		.flex-wrapper {
			flex-wrap: wrap;
			.left {
				max-width: 100%;
				border-right: none;
				padding-right: 0;
				.article-wrap {
					margin-top: 0px;
					margin-left: 2px;

					.title {
						display: none;
					}
					.flex-wrap {
						flex-wrap: wrap;
						.left-box {
							width: 100%;
						}
					}
					.card-box {
						display: block;
						border-bottom: 1px solid #eee;
						padding-bottom: 30px;
						margin-bottom: 30px;
						/* &:last-child {
							padding-bottom: 0;
							margin-bottom: 0;
						} */
					}
					.article-card {
						flex-wrap: wrap;
						gap: 16px;
						.cardimgbox {
							width: 100%;
						}
						.article-img {
							width: 100%;
							height: 0;
							padding-bottom: 55.4%;
							border-radius: 16px;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
						}
						.text-box {
							max-width: 584px;
							width: 100%;
							margin-left: 10px;
							.tag-box {
								gap: 12px;
								.cate {
									font-size: 12px;
									font-weight: 400;
								}
							}
							h3 {
								margin-top: 6px;
								font-size: 18px;
								overflow: hidden;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								-webkit-box-orient: vertical;
							}
							.content {
								margin-top: 8px;
								font-size: 12px;
								padding-right: 0px;
							}
							.flex {
								margin-top: 9px;
								p {
									font-size: 12px;
									margin-right: 21px;
								}
								.name {
									font-size: 12px;
									margin-right: 21px;
								}
								.date {
									font-size: 12px;
								}
							}
						}
					}
					.right-box {
						display: none;
					}
				}
			}
			.mo-banner-wrap {
				width: 100%;
				display: block;
				.mo-banner {
					padding: 22px 24px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					border-radius: 8px;
					p {
						font-size: 18px;
						font-weight: 600;
						line-height: 140%;
						max-width: 185px;
						word-break: keep-all;
						margin-bottom: 12px;
					}
					span {
						display: flex;
						align-items: center;
						gap: 6px;
						font-size: 12px;
						font-weight: 400;
						line-height: normal;
						img {
							width: 4px;
							height: 8px;
						}
					}
				}
				.line {
					border-bottom: none;
					margin: 60px -20px 0 -20px;
				}
			}
		}
	}
`;
export const SkeletonRightWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.right {
		margin-top: 0px;
		padding-left: 0;
		width: 340px !important;
		.top-box {
			.topimgs {
				background: #f2f2f2 !important;
				width: 88px;
				height: 88px;
				border-radius: 50%;
			}
			.text-box {
				h3 {
					border-radius: 8px;
					background: #f2f2f2;
					height: 21px;
					width: 58%;
				}
				p {
					border-radius: 8px;
					background: #f2f2f2;
					height: 19px;
					width: 53%;
				}
			}
		}
		.content {
			width: 100%;
			border-radius: 10px;
			background: #f2f2f2;
			height: 120px;
		}

		.series {
			margin-top: 60px;
			h3 {
				margin-bottom: 20px;
				margin-left: 8px;
			}
			.series-list {
				.list {
					gap: 20px;
					margin-top: 20px;
					display: flex;
					align-items: center;
					.seriesimg {
						width: 58px;
						height: 58px;
						background: #f2f2f2;
						border-radius: 50%;
					}
					.text-box {
						width: 100%;
						h4 {
							border-radius: 8px;
							background: #f2f2f2;
							height: 21px;
							width: 28%;
						}
						p {
							border-radius: 8px;
							background: #f2f2f2;
							height: 19px;
							width: 23%;
						}
					}
				}
			}
		}
		.tag {
			margin-top: 60px;
			h3 {
				margin-left: 8px;
			}
			ul {
				border-radius: 10px;
				background: #f2f2f2;
				height: 223px;
			}
		}
	}
	@media screen and (max-width: 768px) {
		width: 100%;
		.right {
			margin-top: 0px;
			padding-left: 0;
			max-width: 100%;
			width: 100% !important;
			.top-box {
				display: none;
			}
			.content {
				display: none;
			}

			.series {
				margin-top: 60px;
				h3 {
					margin-bottom: 20px;
					margin-left: 8px;
				}
				.series-list {
					.list {
						gap: 20px;
						margin-top: 20px;
						.seriesimg {
							width: 58px;
							height: 58px;
						}
					}
				}
			}
			.tag {
				margin-top: 60px;
				h3 {
					margin-left: 8px;
				}
				ul {
					margin-top: 20px;
				}
			}
		}
	}
`;
export const SkeletonBannerWrapper = styled.div`
	margin-top: 100px;
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.banner {
		width: 100%;
		background: #f2f2f2 !important;
		height: 194px;
	}
`;
export const SkeletonMoBannerWrapper = styled.div`
	margin-top: 100px;
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.banner {
		width: 100%;
		border-radius: 8px;
		background: #f2f2f2;
		height: 120px;
	}
`;
export const SkeletonMoRightWrapper = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		animation: blink 1s linear infinite alternate;
		@keyframes blink {
			from {
				opacity: 0.3;
			}
			to {
				opacity: 1;
			}
		}
		margin-top: 30px;
		display: block;
		width: 100%;
		.mo-top-box {
			display: flex;
			align-items: center;
			gap: 24px;
			.topimg {
				width: 68px;
				height: 68px;
				background-image: none;
				background: #f2f2f2;
				border-radius: 50%;
			}
			.text-box {
				width: 100%;
				h3 {
					background: #f2f2f2;
					height: 21px;
					width: 28%;
					background-color: #f2f2f2;
					border-radius: 8px;
				}
				p {
					margin-top: 6px;
					font-size: 13px;
					font-weight: 400;
					height: 21px;
					width: 23%;
					background-color: #f2f2f2;
					border-radius: 8px;
				}
			}
		}
	}
`;
export const SkeletonSerieWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.right {
		margin-top: 0px;
		padding-left: 0;
		width: 340px !important;
	}
	.series {
		margin-top: 60px;
		h3 {
			margin-bottom: 20px;
			margin-left: 8px;
		}
		.series-list {
			.list {
				gap: 20px;
				margin-top: 20px;
				display: flex;
				align-items: center;
				.seriesimg {
					width: 58px;
					height: 58px;
					background: #f2f2f2;
					border-radius: 50%;
				}
				.text-box {
					width: 100%;
					h4 {
						border-radius: 8px;
						background: #f2f2f2;
						height: 21px;
						width: 58%;
					}
					p {
						border-radius: 8px;
						background: #f2f2f2;
						height: 19px;
						width: 53%;
					}
				}
			}
		}
	}
	.tag {
		margin-top: 60px;
		h3 {
			margin-left: 8px;
		}
		ul {
			border-radius: 10px;
			background: #f2f2f2;
			height: 223px;
		}
	}
	@media screen and (max-width: 768px) {
		width: 100%;
		.right {
			margin-top: 0px;
			padding-left: 0;
			max-width: 100%;
			width: 100% !important;
			.top-box {
				display: none;
			}
			.content {
				display: none;
			}

			.series {
				margin-top: 60px;
				h3 {
					margin-bottom: 20px;
					margin-left: 8px;
				}
				.series-list {
					.list {
						gap: 20px;
						margin-top: 20px;
						.seriesimg {
							width: 58px;
							height: 58px;
						}
					}
				}
			}
			.tag {
				margin-top: 60px;
				h3 {
					margin-left: 8px;
				}
				ul {
					margin-top: 20px;
				}
			}
		}
	}
`;
export const SkeletonSingleWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.article-wrap {
		margin-top: 98px;
		margin-left: 2px;
		.tag-box {
			width: 23%;
			height: 22px;
			border-radius: 6px;
			background: #f2f2f2;
		}
		.title {
			width: 85%;
			font-size: 42px;
			border-radius: 10px;
			background: #f2f2f2;
			height: 48px;
			margin-top: 18px;
			margin-bottom: 30px;
		}
		.share-box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			.left {
				display: flex;
				gap: 14px;
				border-right: none;
				a {
					border-radius: 12px;
					background: #f7f7f7;
					width: 36px;
					height: 36px;
					position: relative;
					img {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
			.right {
				margin-top: 0;
				border-radius: 9px;
				background: #f2f2f2;
				height: 36px;
			}
		}
	}
	.left-box {
		.article-box {
			margin-top: 39px;
			.article {
				border-radius: 30px;
				background: #f2f2f2;
				height: 500px;
			}
			.content {
				margin-top: 40px;
				border-radius: 14px;
				background: #f2f2f2;
				height: 416px;
			}
		}
	}
	@media screen and (max-width: 768px) {
		.mo-top-wrap {
			display: block;
			margin-top: 30px;
			.mo-top-box {
				display: flex;
				align-items: center;
				gap: 24px;
				.imgbox {
					display: flex;
					align-items: end;
					.topimg {
						width: 68px;
						height: 68px;
						background-image: none !important;
						background: #f2f2f2;
						border-radius: 50%;
					}
				}
				.text-box {
					width: 100%;
					h3 {
						border-radius: 8px;
						background: #f2f2f2;
						height: 21px;
						width: 58%;
					}
					p {
						margin-top: 6px;
						border-radius: 8px;
						background: #f2f2f2;
						height: 19px;
						width: 53%;
					}
				}
			}
			.mo-content {
				display: block;
				margin-top: 26px;
				border-radius: 10px;
				background: rgba(0, 0, 0, 0.03);
				padding: 12px;
			}
		}
	}
`;
export const SkeletonBulletinWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.bulletin-list {
		display: flex;
		align-items: center;
		gap: 20px;
		margin-top: 30px;
		margin-left: -3px;
		.photo {
			width: 88px;
			height: 88px;
			border-radius: 12px;
			background: #f2f2f2 !important;
		}
		.text-box {
			width: 100%;
			ul {
				width: 65%;
				border-radius: 6px;
				background: #f2f2f2;
				height: 16px;
			}
			h4 {
				width: 87%;
				margin-top: 8px;
				border-radius: 6px;
				background: #f2f2f2;
				height: 18px;
			}
			.date-box {
				width: 64%;
				margin-top: 10px;
				border-radius: 6px;
				background: #f2f2f2;
				height: 18px;
			}
		}
	}
`;
export const SkeletonRecentWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.article-wrap {
		display: flex;
		gap: 30px;
		.card {
			width: calc((100% - 60px) / 3);
		}
		.banner {
			width: 100%;
			height: 0;
			padding-bottom: 64%;
			border-radius: 18px;
			border-radius: 18px;
			background: #f2f2f2;
		}
		.content {
			margin-top: 20px;
			margin-left: 10px;
			ul {
				border-radius: 6px;
				background: #f2f2f2;
				width: 46%;
				height: 18px;
			}
			.title {
				margin-top: 6px;
				border-radius: 6px;
				background: #f2f2f2;
				width: 94%;
				height: 26px;
				margin-bottom: 0;
			}
			.cont {
				margin-top: 9px;
				border-radius: 6px;
				background: #f2f2f2;
				width: 78%;
				height: 18px;
			}
			.flex {
				display: flex;
				align-items: center;
				margin-top: 12px;
				border-radius: 6px;
				background: #f2f2f2;
				width: 59%;
				height: 18px;
			}
		}
	}
`;
export const SkeletonTopWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.top-box {
		display: flex;
		align-items: center;
		gap: 21px;
		.imgbox {
			display: flex;
			align-items: end;
			.topimg {
				width: 88px;
				height: 88px;
				background-image: none !important;
				background: #f2f2f2;
				border-radius: 50%;
			}
		}
		.text-box {
			width: 100%;
			h3 {
				border-radius: 8px;
				background: #f2f2f2;
				height: 21px;
				width: 58%;
			}
			p {
				border-radius: 8px;
				background: #f2f2f2;
				height: 19px;
				width: 53%;
			}
		}
	}
	.content {
		margin-top: 30px;
		border-radius: 10px;
		background: #f2f2f2;
		height: 120px;
	}
`;
export const SkeletonTagWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	ul {
		border-radius: 10px;
		background: #f2f2f2;
		width: 100%;
		height: 223px;
	}
`;

export const SkeletonMoRecentWrapper = styled.div`
	display: block;
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}

	.article-wrap {
		.banner {
			width: 100%;
			height: 0;
			padding-bottom: 55%;
			border-radius: 16px;
			border-radius: 16px;
			background: #f2f2f2;
		}
		.content-box {
			margin-top: 20px;
			padding-left: 10px;
			ul {
				width: 54%;
				height: 16px;
				border-radius: 6px;
				background: #f2f2f2;
			}
			.title {
				margin-top: 6px;
				margin-bottom: 0;
				margin-left: 0;
				width: 89%;
				height: 20px;
				border-radius: 6px;
				background: #f2f2f2;
			}
			.cont {
				margin-top: 8px;
				border-radius: 8px;
				background: #f2f2f2;
				height: 36px;
				color: #888;
			}
			.flex {
				border-radius: 6px;
				background: #f2f2f2;
				width: 71%;
				height: 18px;
				margin-top: 14px;
			}
		}
	}
`;

export const SkeletonWritertWrapper = styled.div`
	animation: blink 1s linear infinite alternate;
	@keyframes blink {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}
	.writer {
		position: relative;
		.writer-user-box {
			max-width: 760px;
			width: 100%;
			border-radius: 20px;
			background: #000;
			color: #fff;
			margin-top: 100px;
			padding: 36px 50px;
			position: relative;
			.bg {
				background-image: url(/images/bg03.png);
				background-repeat: no-repeat;
				width: 100%;
				height: 192px;
				background-size: cover;
				background-repeat: no-repeat;
				position: absolute;
				top: 0;
				right: 0;
			}
			.user-flex {
				display: flex;
				justify-content: space-between;
				position: relative;
				z-index: 1;
				.user-left {
					display: flex;
					gap: 44px;
					width: 100%;
					.user {
						width: 120px;
						height: 120px;
						border-radius: 50%;
						border: 1px solid rgba(0, 0, 0, 0.4);
						background: #f2f2f2;
					}
					.user-name {
						display: flex;
						gap: 12px;
						width: 100%;
						h3 {
							border-radius: 10px;
							background: #f2f2f2;
							height: 32px;
							width: 20%;
						}
						p {
							border-radius: 10px;
							background: #f2f2f2;
							height: 18px;
							width: 28%;
							position: relative;
							top: 15px;
						}
					}
				}
				.user-right {
					background: #f2f2f2;
					height: 18px;
					width: 20%;
					border-radius: 10px;
					position: relative;
					top: 10px;
				}
			}
		}
		.under-article {
			border-radius: 20px;
			border: 1px solid #eee;
			background: #fff;
			padding: 28px 34px;
			max-width: 566px;
			width: 100%;
			position: absolute;
			top: 95px;
			right: 2px;
			display: flex;
			.article-left {
				width: 18%;
				border-right: 1px solid #eee;
				padding-right: 24px;
				h2 {
					width: 80%;
					border-radius: 8px;
					background: #f2f2f2;
					height: 24px;
				}
				p {
					border-radius: 6px;
					background: #f2f2f2;
					height: 16px;
					opacity: 1 !important;
					margin-top: 11px;
				}
			}
			.mo-article-left {
				display: none;
			}
			.article-right {
				padding-left: 24px;
				width: 100%;
				.cont {
					max-width: 385px;
					width: 100%;
					border-radius: 8px;
					background: #f2f2f2;
					height: 60px;
					opacity: 1;
				}
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.writer {
			.writer-user-box {
				padding: 26px 40px;
				.bg {
					border-radius: 20px;
				}
				.user-flex {
					display: flex;
					justify-content: space-between;
					position: relative;
					z-index: 1;
					.user-left {
						gap: 18px;
						.user {
							width: 80px;
							height: 80px;
						}
						.user-name {
							display: flex;
							gap: 12px;
							h3 {
								font-size: 20px;
							}
							p {
								font-size: 13px;
								top: 8px;
							}
						}
					}
					.user-right {
						p {
							position: relative;
							top: -5px;
						}
					}
				}
			}
			.under-article {
				padding: 18px 28px;
				max-width: 466px;
				width: 100%;
				top: 115px;
				right: 2px;
				.article-left {
					width: 20%;
				}
			}
		}
	}
	@media screen and (max-width: 768px) {
		.writer {
			position: relative;
			padding-right: 10px;
			.writer-user-box {
				max-width: 100%;
				border-radius: 18px;
				margin-top: 0px;
				padding: 24px 30px;
				height: 132px;
				.bg {
					background-image: url(/images/bg04.png);
					width: 100%;
					height: 132px;
				}
				.user-flex {
					.user-left {
						display: flex;
						gap: 28px;
						.user {
							width: 68px;
							height: 68px;
						}
						.user-name {
							flex-direction: column;
							gap: 4px;
							margin-top: 10px;
							h3 {
								font-size: 18px;
							}
							p {
								font-size: 12px;
								top: 0;
							}
						}
					}
					.user-right {
						display: none;
					}
				}
			}
			.under-article {
				border-radius: 18px;
				padding: 22px;
				max-width: 100%;
				width: calc(100% - 18px);
				top: 107px;
				right: 2px;
				flex-wrap: wrap;
				.article-left {
					display: none;
				}
				.mo-article-left {
					width: 100%;
					display: flex;
					justify-content: space-between;
					padding-bottom: 16px;
					border-bottom: 1px solid #eee;
					.flex {
						display: flex;
						align-items: center;
						gap: 4px;
						width: 100%;
						h2 {
							border-radius: 6px;
							background: #f2f2f2;
							width: 21%;
							height: 18px;
						}
					}
					.mo-right {
						border-radius: 6px;
						background: #f2f2f2;
						width: 21%;
						height: 18px;
					}
				}
				.article-right {
					padding-left: 0;
					margin-top: 16px;
					.cont {
						max-width: 100%;
						font-size: 12px;
						height: 68px;
					}
				}
			}
		}
	}
`;

export const SkeletonPocketWrapper = styled.div`
	.pocket-wrap {
		margin-top: 54px;
		padding-bottom: 80px;
		.pocket-list {
			display: flex;
			flex-wrap: wrap;
			gap: 36px;
			.pocket {
				width: calc((100% - 72px) / 3);
				height: 295px;
				border-radius: 18px;
				padding: 30px;
				border-radius: 18px;
				background: #f2f2f2;
			}
			.mo-pocket {
				display: none;
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.pocket-wrap {
			margin-top: 54px;
			padding-bottom: 80px;
			.pocket-list {
				gap: 20px;
				.pocket {
					width: calc((100% - 40px) / 2);
					border-radius: 18px;
					padding: 20px;
					h2 {
						font-size: 24px;
					}
				}
				.mo-pocket {
					display: none;
				}
			}
		}
	}
	@media screen and (max-width: 768px) {
		.pocket-wrap {
			margin-top: 38px;
			padding-bottom: 40px;
			.pocket-list {
				display: flex;
				flex-wrap: wrap;
				gap: 24px;
				.pocket {
					display: none;
				}
				.mo-pocket {
					display: block;
					width: 100%;
					height: 240px;
					padding: 28px;
					border-radius: 18px;
					background: #f2f2f2;
				}
			}
		}
	}
`;
